<template>
  <v-container>
    <div class="page calculating" v-if="calculating">
      <v-row>
        <v-col cols="12" class="d-flex align-center justify-center">
          <div class="calculating_block">
            <v-card transition="slide-x-transition">
              <v-card-text>
                <div class="drawer_frame">
                  <SmilesDrawer
                    :id="`preview_load`"
                    :smiles="compound"
                    :width="290"
                    :height="290"
                    class="drawer"
                    ref="element"
                  ></SmilesDrawer>
                </div>
                <div class="start_txt">
                  <div class="start_smiles d-flex align-center justify-center">
                    <div>{{ compound }}</div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <h2>Calculating the ADMET/PK result…</h2>
            <v-progress-linear
              color="primary"
              height="10"
              :value="progress"
              striped
            ></v-progress-linear>
            <div class="row d-flex justify-space-between calculating_number">
              <v-col><span>0%</span></v-col>
              <v-col class="text-right"><span>{{progress}}%</span></v-col>
            </div>
            <div class="calculating_deco">
              <div>H-bond acceptors</div>
              <div>Water solubility</div>
              <div>Clearance</div>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item-two-line"
              ></v-skeleton-loader>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="page start" v-else>
      <v-tabs centered>
        <v-tab>Example compound</v-tab>
        <v-tab>Keying SMILES</v-tab>
        <v-tab-item>
          <h2 v-text="$t('start.title')" class="py-4"></h2>
          <v-row class="compound_items">
            <v-col cols="12">
              <v-row class="d-flex align-items-stretch">
                <v-col
                  class="col-lg-4 col-md-6 col-sm-12"
                  v-for="(item, i) in samplesCompounds"
                  :key="i"
                  align="center"
                >
                  <v-card>
                    <v-card-text>
                      <div class="drawer_frame">
                        <SmilesDrawer
                          :id="`preview` + i"
                          :smiles="item"
                          :width="290"
                          :height="290"
                          class="drawer"
                          ref="element"
                        ></SmilesDrawer>
                      </div>
                      <div class="start_txt">
                        <v-btn
                          class="btn_touch"
                          color="primary"
                          v-text="$t('start.touch_for_screening')"
                          @click="explain(item)"
                        ></v-btn>
                        <div
                          class="
                            start_smiles
                            d-flex
                            align-center
                            justify-center
                          "
                        >
                          <div>{{ item }}</div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <h2 v-text="$t('start.title2')" class="py-4"></h2>
          <v-row class="compound_type">
            <v-col class="col-md-10 col-7">
              <v-text-field
                v-model="smiles"
                :placeholder="$t('start.keying_smiles')"
                single-line
                clearable
                dense
                outlined
                autocomplete="off"
                @keypress="onKeypress"
              ></v-text-field>
            </v-col>
            <v-col class="col-md-2 col-5">
              <v-btn
                class="btn_previewSmile"
                :loading="applying"
                @click="onPreview"
              >
                <v-icon size="24" class="v-icon-left"
                  >mdi-card-search-outline</v-icon
                >
                <span v-text="$t('start.smiles_preview')"></span>
              </v-btn>
            </v-col>
          </v-row>
          <CompoundPreview @done="done" ref="preview"></CompoundPreview>
          <div class="explainable_bottom">
            <v-container>
              <div class="frame frame-bottom">
                <v-row class="align-center justify-end">
                  <v-col class="col-md-3 col-8 text-center">
                    <v-btn
                      class="btn_optimize"
                      color="primary"
                      :disabled="canonical == null"
                      @click="explain(canonical)"
                    >
                      <span v-text="$t('start.screening_compound')"></span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
  </v-container>
</template>

<script>
import SmilesDrawer from "@/components/SmilesDrawer";
import CompoundPreview from "@/components/CompoundPreview";
import Compounds from "@/components/Compounds";

export default {
  name: "Start",
  mixins: [Compounds],
  components: {
    SmilesDrawer,
    CompoundPreview,
  },
  data() {
    return {
      preview: {},
      applying: false,
      smiles: "",
      canonical: null,
      compound: "",
      enable: false,
      calculating: false,
      progress: 0
    };
  },
  methods: {
    onKeypress(e) {
      if (e.keyCode == 13) this.onPreview();
    },
    onPreview() {
      if (this.smiles != undefined && this.smiles != "") {
        this.applying = true;
        this.preview.name = undefined;
        this.$refs.preview.onCheck(this.smiles);
      }
    },
    done(v) {
      this.applying = false;
      this.smiles = "";
      this.canonical = null;
      if (!v) this.enable = true;
      else this.canonical = v;
    },
    loadProgress() {
      if (this.progress != 100) {
        this.progress += 4;
        return setTimeout(() => {
          this.loadProgress();
        }, 200);
      } else {
        this.calculating = false;
      }
    },
    explain(item) {
      if (this.calculating) return;
      this.calculating = true;
      this.loadProgress();
      this.compound = item;
      let data = {
        value: item
      };
      const token = this.$root.userToken;
      this.$ajax(this.$root.api + "/origin", {
        method: "post",
        headers: {
          Authorization: token,
          "Content-Type": "application/json; charset=UTF-8",
        },
        data: data
      })
        .then((res) => {
          if (res.data != false) {
            let d = JSON.parse(JSON.stringify(res.data || [])) || {};
            this.$router.push(`/explainable/${d}`);
          } else {
            this.$root.$somethingWrong(res.data);
          }
          // this.calculating = false;
          this.$emit("done");
        })
        .catch((error) => {
          this.errorMsg = error;
          this.$emit("done");
        });
    }
  }
};
</script>
